import { IFatigueRulesFormState, IFatigueRulesVersion } from 'types/fatigueRules.interface'

export const ACTIVE_RULES_FORM: IFatigueRulesFormState = {
  maxConsecutiveHours: '12',
  maxHoursPer7Days: '56',
  minRestBetweenShifts: '11',
  elevatedAt: '0.45',
  highAt: '0.65',
  criticalAt: '0.85',
  notes: '',
}

export const MOCK_FATIGUE_RULES_VERSIONS: IFatigueRulesVersion[] = [
  {
    id: 2,
    publishedAt: 'Apr 1, 2026, 02:00 AM',
    active: true,
    summary: '12h/shift · 56h/7d · rest ≥ 11h · E 0.45/H 0.65/C 0.85',
    note: 'Tightened ELEVATED/HIGH thresholds after Q1 review',
    rules: ACTIVE_RULES_FORM,
  },
  {
    id: 1,
    publishedAt: 'Jan 1, 2026, 01:00 AM',
    active: false,
    summary: '12h/shift · 60h/7d · rest ≥ 10h · E 0.5/H 0.7/C 0.85',
    note: 'Initial fatigue rule set — Q1 baseline',
    rules: {
      maxConsecutiveHours: '12',
      maxHoursPer7Days: '60',
      minRestBetweenShifts: '10',
      elevatedAt: '0.5',
      highAt: '0.7',
      criticalAt: '0.85',
      notes: '',
    },
  },
]
